// Point UNIQUE de lecture du jeton d'authentification admin/client.
// Toute l'app lit le jeton sous la clé 'ose_auth' (cf. context/AuthContext.js).
// Ne jamais réintroduire d'anciennes clés ('admin_token', 'token', 'ose_token').

export const TOKEN_KEY = 'ose_auth';

// Lit le jeton courant (sessionStorage prioritaire, repli localStorage).
export function getToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

// En-têtes d'un appel ADMIN authentifié.
// Ajoute Authorization: Bearer <token> uniquement si un jeton est présent.
// `extra` permet de fusionner d'autres en-têtes (ex: Content-Type).
export function authHeaders(extra = {}) {
  const t = getToken();
  return t ? { ...extra, Authorization: `Bearer ${t}` } : { ...extra };
}
